module.exports = __webpack_public_path__ + "img/415.806420c7.gif";